import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=2da84a51&scoped=true&"
import script from "./BasePagination.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BasePagination.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=2da84a51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da84a51",
  null
  
)

export default component.exports